import { selectCurrentProjectId } from "../../../../global/globalSliceCommon";
import { IRootState } from "../../../../store";
import { selectIssueBoardId } from "../redux/selectors/issueCommonSelectors";
import { createSelector } from "reselect";
import { GetProjectByProjectIdIssueLogsApiResponse, openapi } from "../../../../../openapi";
import { selectHttpIssueBoard } from "../redux/selectors/issueRtkSelectors";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";

export const selectIssueLogsCreatedAtRange = (state: IRootState) => state.issueReducerNew.issueLogsCreatedAtRange;

export const selectIssueLogsPageSize = (state: IRootState) => state.issueReducerNew.issueLogsPageSize;

export const selectIssueLogsCurrentPage = (state: IRootState) => state.issueReducerNew.issueLogsCurrentPage;
// issueCommonSelectors.ts (add this)

export const selectIssueLogsBaseArgs = (state: IRootState) => {
  const projectId = selectCurrentProjectId(state);
  const boardId = selectIssueBoardId(state);
  const pageSize = selectIssueLogsPageSize(state);
  const range = selectIssueLogsCreatedAtRange(state);
  const page = selectIssueLogsCurrentPage(state);

  const createdAtFrom = range[0] ? `${range[0]}T00:00:00.000Z` : undefined;
  const createdAtTo = range[1] ? `${range[1]}T23:59:59.999Z` : undefined;

  return {
    projectId,
    boardId,
    createdAtFrom,
    createdAtTo,
    limit: pageSize,
    page: page, // Overridden in calls
    includeTotalCount: "true" as const,
  };
};

export const selectHttpIssueLogsOnBoard = createSelector(
  [selectIssueLogsBaseArgs, (s: IRootState) => s],
  (args, state) => {
    if (!args) return undefined;
    const q = openapi.endpoints.getProjectByProjectIdIssueLogs.select(args)(state);
    return q.data;
  },
);

export const selectIssueLogsFormatted = createSelector(
  [selectHttpIssueLogsOnBoard, selectHttpIssueBoard],
  (datasource, issueBoard: IIssueBoardApi): GetProjectByProjectIdIssueLogsApiResponse => {
    const otherAttributesConfig = issueBoard?.otherAttributesConfig;

    const items = (datasource?.items ?? []).map((log) => {
      // By default: ingen endring
      let next = log;

      // otherAttributes: bytt kolonnenavn (immutable)
      if (otherAttributesConfig && log.column?.startsWith("otherAttribute")) {
        const otherAttributeKey = log.column.replace("otherAttributesData.", "");
        const columnLabel = otherAttributesConfig[otherAttributeKey]?.label ?? log.column;

        if (columnLabel !== log.column) {
          next = { ...next, column: columnLabel };
        }
      }

      const saklabel = issueBoard?.issueNameSetting ?? "Sak";
      const taskLabebl = issueBoard?.taskNameSetting ?? "Aksjon";

      // taskOrIssue label (immutable)
      if (log.taskOrIssue === "ISSUE") {
        next = { ...next, taskOrIssue: saklabel as any };
      } else if (log.taskOrIssue === "TASK") {
        next = { ...next, taskOrIssue: taskLabebl as any };
      }

      return next;
    });

    return {
      ...(datasource ?? { items: [] }),
      items,
    };
  },
);
